import React from 'react'
import { Popup } from 'devextreme-react/popup'
import { fixDataType, renderUrl, renderDate } from '../../utils/model-data'
import { isHiddenField } from '../../utils/permissions'
import { useAuth } from '../../contexts/auth'

export default function Rowdetails(props: any) {
	const { fields, urls, values, lookups, onHide, model } = props

	const { user } = useAuth()

	const renderValue = (field: any, value: any) => {
		const dataType = fixDataType(field.dataType, field.dataField)

		if (dataType === 'date') {
			return renderDate(value)
		}

		if (urls.indexOf(field.dataField as never) > -1) {
			return renderUrl(value)
		}

		if (lookups && lookups.hasOwnProperty(field.dataField)) {
			return lookups[field.dataField][value] ?? value ?? ''
		}

		return value
	}

	const renderContent = () => {
		return (
			<>
				{fields.map(
					(field: any, ndx: number) =>
						field.visible &&
						!isHiddenField(user, model || '', field.dataField) && (
							<div key={field.dataField}>
								<strong>{field.caption ?? field.dataField}: </strong>
								{renderValue(field, values[field.dataField])}
							</div>
						)
				)}
			</>
		)
	}

	return (
		<Popup
			visible={true}
			dragEnabled={true}
			resizeEnabled={true}
			showCloseButton={true}
			contentRender={renderContent}
			title="Row Details"
			position="center"
			hideOnOutsideClick={() => {
				return true
			}}
			onHiding={onHide}
		/>
	)
}
